type SaveTimeRecordError = {
  timesheetDeadlineExceeded: boolean;
};

const saveTimeRecordError: SaveTimeRecordError = {
  timesheetDeadlineExceeded: false,
};

export type { SaveTimeRecordError };

export { saveTimeRecordError };
